import { render } from "./EmployeeViewPendingRequest.vue?vue&type=template&id=383d134e"
import script from "./EmployeeViewPendingRequest.vue?vue&type=script&lang=js"
export * from "./EmployeeViewPendingRequest.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__